import { render, staticRenderFns } from "./PrivacyIndex.vue?vue&type=template&id=2b0a28de&scoped=true"
import script from "./PrivacyIndex.vue?vue&type=script&lang=js"
export * from "./PrivacyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a28de",
  null
  
)

export default component.exports